/* eslint-disable import/prefer-default-export */
import { TranslationMapMessages, MapMessages } from "../interfaces";

export const messages: TranslationMapMessages = {
  [MapMessages.updateVehicleCurrentPosition]: "Actualizar la posición actual del vehículo",
  [MapMessages.errorFetchingAddressData]: "Error al buscar datos de dirección",
  [MapMessages.locationSearchTitle]: "Búsqueda de ubicación",
  [MapMessages.typeLocationLabel]: "Escriba la ubicación",
  [MapMessages.allVehiclesSearchLabel]: "Búsqueda por placa, descripción o cód.",
  [MapMessages.addressSearchLabel]: "Búsqueda por dirección",
  [MapMessages.route]: "Ruta",
  [MapMessages.outwardTrip]: "Ida",
  [MapMessages.returnTrip]: "Vuelta",
  [MapMessages.names]: "Nombres",
  [MapMessages.licensePlates]: "Placas",
  [MapMessages.alerts]: "Alertas",
  [MapMessages.states]: "Estados",
  [MapMessages.events]: "Eventos",
  [MapMessages.viewLocation]: "Visualizar ubicación",
  [MapMessages.zmrc]: "ZMRC",
  [MapMessages.invalidPolygon]: "Polígono no válido",
  [MapMessages.point]: "Punto",
  [MapMessages.stopped]: "detenido",
  [MapMessages.distanceToConstruction]: "Distancia de la obra",
  [MapMessages.showOnMap]: "Mostrar en el mapa",
  [MapMessages.areas]: "Áreas",
  [MapMessages.construction]: "Obra",
  [MapMessages.constructionNotLocked]: "Obra aún sin ubicación fija",
  [MapMessages.invoiceAddress]: "Dirección de la nota",
  [MapMessages.plant]: "Planta",
  [MapMessages.trustedLocation]: "Lugar confiable",
  [MapMessages.discharges]: "Descargas",
  [MapMessages.dischargeInConstruction]: "Descarga en la obra",
  [MapMessages.dischargeOutsideConstruction]: "Descarga fuera de la obra",
  [MapMessages.alertTag]: "Alerta",
  [MapMessages.eventTag]: "Evento",
  [MapMessages.stateTag]: "Estado",
  [MapMessages.legendHint]: "Alerta (rojo) indica algo a revisar; el evento es solo informativo.",
  [MapMessages.legendOrderHint]: "Los números marcan lo que pasó en el viaje, en el orden de la línea de tiempo.",
  [MapMessages.timeline]: "Línea de tiempo",
  [MapMessages.replayPlay]: "Reproducir trayecto",
  [MapMessages.replayPause]: "Pausar",
  [MapMessages.travelMoment]: "Momento del viaje",
  [MapMessages.playbackSpeed]: "Velocidad de reproducción",
  [MapMessages.replayFromHere]: "Reproducir desde aquí",
  [MapMessages.replayHint]: "Clic derecho en el trayecto: reproducir desde ese punto.",
  [MapMessages.fullscreen]: "Pantalla completa",
  [MapMessages.exitFullscreen]: "Salir de pantalla completa",
  [MapMessages.fullscreenHint]: "Pantalla completa: mapa, reproducción, línea de tiempo y datos del viaje lado a lado. La mejor forma de analizar el viaje.",
  [MapMessages.automaticTravel]: "Viaje automático (sin nota): ninguna obra reconocida en este viaje",
  [MapMessages.automaticConstruction]: "obra automática",
  [MapMessages.travelTime]: "Tiempo de viaje",
  [MapMessages.fromConstruction]: "de la obra",
  [MapMessages.constructionHelp]: "Punto de la obra y el radio usado para En obra y Descargando.\nLleno: las descargas ya confirmaron el lugar y quedó fijo.",
  [MapMessages.constructionNotLockedHelp]: "El punto todavía sigue las descargas: puede cambiar en las próximas entregas hasta que confirmen el lugar.",
  [MapMessages.invoiceAddressHelp]: "Dónde cae en el mapa la dirección de la nota.\nEs solo referencia: la obra es el círculo amarillo.",
  [MapMessages.plantHelp]: "Planta de donde salió el viaje y a donde volvió.",
  [MapMessages.trustedLocationHelp]: "Lugar registrado, como taller, gasolinera o estacionamiento.\nMientras el camión está allí, el estado es En lugar confiable.",
  [MapMessages.dischargeInConstructionHelp]: "Punto donde la descarga se registró dentro de la obra.",
  [MapMessages.dischargeOutsideConstructionHelp]: "Punto donde la descarga se registró fuera de la obra.\nGenera la alerta de descarga indebida.",
  [MapMessages.addressSearchLoading]: "Buscando direcciones...",
  [MapMessages.addressSearchUnavailable]: "No fue posible buscar la dirección ahora. Inténtelo de nuevo o escriba las coordenadas (latitud, longitud)."
};
